import React from 'react';
import { pdf } from '@react-pdf/renderer';
import API_BASE_URL from '../config/apiConfig';
import { COMPANY_ID } from '../config/companyConfig';
import EcOrderInvoiceDocument from '../pdf/documents/EcOrderInvoiceDocument';

const readJson = async (response) => {
  try {
    return await response.json();
  } catch (_) {
    return null;
  }
};

export async function openEcOrderPdf(orderId, token) {
  const headers = { Authorization: `Bearer ${token}` };
  const [orderResponse, brandingResponse] = await Promise.all([
    fetch(`${API_BASE_URL}/ec/order/${orderId}`, { headers }),
    fetch(`${API_BASE_URL}/ec/store/invoice-branding?CompanyId=${encodeURIComponent(COMPANY_ID)}`, { headers }),
  ]);

  const orderResult = await readJson(orderResponse);
  if (!orderResponse.ok || !orderResult?.success || !orderResult.data) {
    throw new Error(orderResult?.message || 'Unable to load this order.');
  }

  const brandingResult = await readJson(brandingResponse);
  const branding = brandingResponse.ok && brandingResult?.success ? brandingResult.data : {};

  const renderPdf = (brandingData) => pdf(
    <EcOrderInvoiceDocument order={orderResult.data} branding={brandingData} />
  ).toBlob();

  let blob;
  try {
    blob = await renderPdf(branding);
  } catch (_) {
    blob = await renderPdf({ ...branding, logoUrl: '' });
  }

  const url = URL.createObjectURL(blob);
  const opened = window.open(url, '_blank');
  if (!opened) {
    const link = document.createElement('a');
    link.href = url;
    link.download = `${orderResult.data.OrderNumber || `Order-${orderId}`}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  window.setTimeout(() => URL.revokeObjectURL(url), 60000);
}
